module.exports = __webpack_public_path__ + "img/nabl_gallery11.c6ba9912.jpg";